module.exports = __webpack_public_path__ + "static/img/HPC.b7a59cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HPC.png
// module id = tlHP
// module chunks = 1